import React, { MouseEvent, Ref } from 'react';
import { IconName } from '../types';
import Icon from '../Icon';

interface Props {
  btn?: string;
  className?: string;
  disabled?: boolean;
  innerRef?: Ref<HTMLButtonElement>;
  icon?: IconName;
  iconr?: IconName;
  id?: string;
  onClick?: (e: MouseEvent) => void;
  text?: string;
  title?: string;
  type?: 'submit' | 'button' | 'reset';
  css?: any;
}

const Button = ({
  btn,
  className = '',
  icon,
  iconr,
  innerRef,
  onClick = () => {},
  text,
  type = 'button',
  css,
  ...props
}: Props) => (
  <button
    className={`${btn ? `btn btn-${btn}` : ''} ${className}`}
    onClick={onClick}
    ref={innerRef}
    type={type}
    {...props}
    style={css}
  >
    {icon && <Icon icon={icon} />}
    {icon && text && <>&nbsp;</>}
    {text && <span>{text}</span>}
    {text && iconr && <>&nbsp;</>}
    {iconr && <Icon icon={iconr} />}
  </button>
);

export default Button;
